export const ADD_NEW_ROW = "ADD_NEW_ROW";
export const DELETE_ROW = "DELETE_ROW";
export const EXAMSERIES_MONTH_HANDLECHANGE = "EXAMSERIES_MONTH_HANDLECHANGE";
export const EXAMSERIES_YEAR_HANDLECHANGE = "EXAMSERIES_YEAR_HANDLECHANGE";
export const EXAM_HANDLECHANGE = "EXAM_HANDLECHANGE";
export const EXAMCENTER_HANDLECHANGE = "EXAMCENTER_HANDLECHANGE";
export const CANDIDATENUMBER_HANDLECHANGE = "CANDIDATENUMBER_HANDLECHANGE";
export const UPDATE_EMPTY_FLAG_EXAM = "UPDATE_EMPTY_FLAG_EXAM";
export const UPDATE_DUPLICATE_FLAG_EXAM = "UPDATE_DUPLICATE_FLAG_EXAM";

export const UPDATE_PERSONAL_INFO_FLAG = "UPDATE_PERSONAL_INFO_FLAG";
export const UPDATE_EXAM_DETAILS_FLAG = "UPDATE_EXAM_DETAILS_FLAG";
export const UPDATE_INSTITUTION_DETAILS_FLAG = "UPDATE_INSTITUTION_DETAILS_FLAG";
export const UPDATE_EXAM_INSTITUTION_REVIEW_FLAG = "UPDATE_EXAM_INSTITUTION_REVIEW_FLAG";
export const UPDATE_INSTITUTION_REVIEW_FLAG = "UPDATE_INSTITUTION_REVIEW_FLAG";
export const UPDATE_REVIEW_FLAG = "UPDATE_REVIEW_FLAG";
export const UPDATE_REVIEW_DETAILS_FLAG = "UPDATE_REVIEW_DETAILS_FLAG";
export const UPDATE_PAY_FLAG = "UPDATE_PAY_FLAG";
export const UPDATE_ADYEN_FLAG = "UPDATE_ADYEN_FLAG";
export const HISTORY_PAY_NAV_FLAG = "HISTORY_PAY_NAV_FLAG";
export const GET_TRANSRIPT_COSTS =  "GET_TRANSRIPT_COSTS";
export const SET_TOTAL_TRANSCRIPT_AMOUNT = "SET_TOTAL_TRANSCRIPT_AMOUNT";
export const SET_TRANSCRIPTS_COST_SUCCESS = "SET_TRANSCRIPTS_COST_SUCCESS";
export const SET_TRANSCRIPTS_COST_ERROR = "SET_TRANSCRIPTS_COST_ERROR";
export const SET_REVIEW_PAY_STATIC_SUCCESS = "SET_REVIEW_PAY_STATIC_SUCCESS";
export const SET_REVIEW_PAY_STATIC_ERROR = "SET_REVIEW_PAY_STATIC_ERROR";
export const RESET_REVIEW_DATA = "RESET_REVIEW_DATA";


export const SET_CURRENT_USER_DATA = "SET_CURRENT_USER_DATA";
export const RESET_CURRENT_USER_DATA = "RESET_CURRENT_USER_DATA";
export const SET_SHOW_LOADER_STAUS = "SET_SHOW_LOADER_STAUS";
export const SET_CURRENT_USER_LOGGED_IN_STATUS = "SET_CURRENT_USER_LOGGED_IN_STATUS";
export const TOGGLE_ALERT = "TOGGLE_ALERT";
export const SET_NAMES_FROM_HISTORY = "SET_NAMES_FROM_HISTORY";

export const ADD_NEW_ROW_INSTITUTE = "ADD_NEW_ROW_INSTITUTE";
export const DELETE_ROW_INSTITUTE = "DELETE_ROW_INSTITUTE";
export const INSTITUTE_HANDLE_CHANGE = "INSTITUTE_HANDLE_CHANGE";
export const UPDATE_EMPTY_FLAG_INSTITUTE = "UPDATE_EMPTY_FLAG_INSTITUTE";
export const UPDATE_DUPLICATE_FLAG_INSTITUTE = "UPDATE_DUPLICATE_FLAG_INSTITUTE";

export const SET_PERSONAL_INFO_DATA = "SET_PERSONAL_INFO_DATA";
export const RESET_PERSONAL_INFO_DATA = "RESET_PERSONAL_INFO_DATA";
export const SAVE_PERSONAL_INFO_DATA = "SAVE_PERSONAL_INFO_DATA";
export const SAVE_PERSONAL_INFO_DATA_ERROR = "SAVE_PERSONAL_INFO_DATA_ERROR";
export const SAVE_PERSONAL_INFO_DATA_SAP_CDC_ERROR = "SAVE_PERSONAL_INFO_DATA_SAP_CDC_ERROR";

export const SUBMIT_INFO = "SUBMIT_INFO";
export const RESET_COMMON_DATA = "RESET_COMMON_DATA";
export const SET_TRANSACTION_ID = "SET_TRANSACTION_ID";
export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";

export const GET_EXAM_CENTRE_LIST = "GET_EXAM_CENTRE_LIST";
export const GET_EXAM_CENTRE_LIST_SUCCESS = "GET_EXAM_CENTRE_LIST_SUCCESS";
export const GET_EXAM_CENTRE_LIST_ERROR = "GET_EXAM_CENTRE_LIST_ERROR";

export const GET_INSTITUTION_LIST = "GET_INSTITUTION_LIST";
export const GET_INSTITUTION_LIST_SUCCESS = "GET_INSTITUTION_LIST_SUCCESS";
export const GET_INSTITUTION_LIST_ERROR = "GET_INSTITUTION_LIST_ERROR";
export const GET_EXAM_SERIES = "GET_EXAM_SERIES";
export const GET_EXAM_SERIES_SUCCESS = "GET_EXAM_SERIES_SUCCESS";
export const GET_EXAM_SERIES_ERROR = "GET_EXAM_SERIES_ERROR";

export const SET_REQUEST_ID = "SET_REQUEST_ID";
export const SAVE_EXAM_DETAILS = "SAVE_EXAM_DETAILS";
export const SAVE_EXAM_DETAILS_SUCCESS = "SAVE_EXAM_DETAILS_SUCCESS";
export const RESET_EXAM_DETAILS = "RESET_EXAM_DETAILS";
export const SAVE_INSTITUTION_DETAILS = "SAVE_INSTITUTION_DETAILS";
export const SAVE_INSTITUTION_DETAILS_SUCCESS = "SAVE_INSTITUTION_DETAILS_SUCCESS";
export const RESET_INSTITUTION_DETAILS = "RESET_INSTITUTION_DETAILS";

export const SET_TRANSACTION_HISTORY_SUCCESS = "SET_TRANSACTION_HISTORY_SUCCESS";
export const SET_TRANSACTION_HISTORY_ERROR = "SET_TRANSACTION_HISTORY_ERROR";
export const UPDATE_TRANSACTION_HISTORY_FLAG = "UPDATE_TRANSACTION_HISTORY_FLAG";
export const GET_TRANSACTION_HISTORY = "GET_TRANSACTION_HISTORY";
export const GET_TRANSACTION_SUMMARY = "GET_TRANSACTION_SUMMARY";
export const SET_TRANSACTION_SUMMARY_SUCCESS = "SET_TRANSACTION_SUMMARY_SUCCESS";
export const SET_TRANSACTION_SUMMARY_ERROR = "SET_TRANSACTION_SUMMARY_ERROR";
export const RESET_HISTORY_FLAGS = "RESET_HISTORY_FLAGS";

export const TERMS_CONDITIONS_ACCEPTED = "TERMS_CONDITIONS_ACCEPTED";
export const GET_TERMS_CONDITIONS = "GET_TERMS_CONDITIONS";
export const GET_TERMS_CONDITIONS_SUCCESS = "GET_TERMS_CONDITIONS_SUCCESS";

export const RESET_STATE_TRANSITION_FLAGS = "RESET_STATE_TRANSITION_FLAGS";
